// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"8427b6c4","287":"9769f2a7","486":"6fe95a04","651":"13a99a07","747":"74e8c73f","797":"bd194bba"}[chunkId] + ".chunk.js";
};